import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconProfilePencil: React.FC<IconProps> = ({ width = 20, height = 20, color = '#23262A' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_11654_84119)">
                <path
                    d="M3.75 3.125H7.5L16.25 16.875H12.5L3.75 3.125Z"
                    stroke={color}
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M8.89687 11.2109L3.75 16.8727"
                    stroke={color}
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M16.2484 3.125L11.1016 8.78672"
                    stroke={color}
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_11654_84119">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconProfilePencil;
